import React from "react";
import "./Solutions.css";
import Slider from "react-slick";

class Solutions extends React.Component {
  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 0,
      slidesToScroll: 1,
      arrows: false,

      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 10000,
          settings: "unslick",
        },
      ],
    };
    return (
      <div className="solutions" id="solutions">
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <div className="container">
          <div className="main-solutions">
            <h4>
              A few
              <span>
                {" "}
                solutions and Decentralized Financial Applications{" "}
              </span>{" "}
              of the
              <span> Anker Platform </span>
            </h4>
            <Slider {...settings}>
              <div className="solutions-block">
                <div className="img">
                  <svg
                    width="65"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.6405 13.2031C41.6405 11.3953 41.1044 9.62804 40.1 8.12487C39.0957 6.6217 37.6681 5.45012 35.9978 4.75829C34.3276 4.06646 32.4897 3.88545 30.7166 4.23814C28.9435 4.59083 27.3148 5.46139 26.0365 6.73973C24.7581 8.01807 23.8876 9.64677 23.5349 11.4199C23.1822 13.193 23.3632 15.0309 24.055 16.7011C24.7469 18.3713 25.9185 19.7989 27.4216 20.8033C28.9248 21.8077 30.692 22.3438 32.4999 22.3438C34.9233 22.341 37.2467 21.3771 38.9603 19.6635C40.6739 17.9499 41.6378 15.6265 41.6405 13.2031ZM28.4464 19.0389C28.5122 18.0086 28.9679 17.0419 29.7208 16.3355C30.4737 15.6291 31.4674 15.236 32.4999 15.236C33.5323 15.236 34.526 15.6291 35.279 16.3355C36.0319 17.0419 36.4876 18.0086 36.5534 19.0389C35.3643 19.868 33.9495 20.3126 32.4999 20.3126C31.0503 20.3126 29.6355 19.868 28.4464 19.0389ZM30.4686 11.1719C30.4686 10.7701 30.5878 10.3774 30.811 10.0434C31.0342 9.70934 31.3514 9.44899 31.7226 9.29525C32.0937 9.14151 32.5021 9.10128 32.8962 9.17966C33.2902 9.25803 33.6521 9.45149 33.9362 9.73557C34.2203 10.0196 34.4137 10.3816 34.4921 10.7756C34.5705 11.1696 34.5303 11.578 34.3765 11.9492C34.2228 12.3204 33.9624 12.6376 33.6284 12.8608C33.2943 13.084 32.9016 13.2031 32.4999 13.2031C31.9614 13.2025 31.4451 12.9883 31.0643 12.6075C30.6835 12.2267 30.4693 11.7104 30.4686 11.1719ZM25.3905 13.2031C25.3893 12.0825 25.6531 10.9774 26.1603 9.97806C26.6674 8.97873 27.4037 8.11346 28.3089 7.45283C29.2142 6.7922 30.2628 6.35494 31.3692 6.1767C32.4756 5.99847 33.6084 6.08431 34.6754 6.42724C35.7423 6.77016 36.713 7.36045 37.5084 8.14995C38.3037 8.93945 38.9012 9.90579 39.252 10.9701C39.6028 12.0345 39.697 13.1667 39.5269 14.2744C39.3569 15.3821 38.9274 16.4339 38.2735 17.344C37.7843 15.905 36.777 14.6997 35.4477 13.9628C35.9945 13.3864 36.3602 12.6623 36.4996 11.8802C36.6391 11.0981 36.5461 10.2922 36.2323 9.56236C35.9185 8.83251 35.3975 8.21069 34.7339 7.77386C34.0704 7.33703 33.2933 7.10435 32.4988 7.10463C31.7043 7.1049 30.9274 7.33811 30.2641 7.7754C29.6008 8.21269 29.0803 8.83487 28.767 9.56493C28.4537 10.295 28.3613 11.1009 28.5013 11.8829C28.6412 12.665 29.0074 13.3888 29.5546 13.9648C28.2256 14.7023 27.2184 15.9077 26.7287 17.3465C25.8578 16.1406 25.3896 14.6906 25.3905 13.2031Z"
                      fill="url(#paint0_linear)"
                    />
                    <path
                      d="M4.0625 51.7971C4.0625 53.605 4.59859 55.3722 5.60297 56.8754C6.60736 58.3785 8.03493 59.5501 9.70516 60.242C11.3754 60.9338 13.2133 61.1148 14.9864 60.7621C16.7595 60.4094 18.3882 59.5389 19.6665 58.2605C20.9449 56.9822 21.8154 55.3535 22.1681 53.5804C22.5208 51.8073 22.3398 49.9694 21.648 48.2992C20.9561 46.6289 19.7846 45.2014 18.2814 44.197C16.7782 43.1926 15.011 42.6565 13.2031 42.6565C10.7797 42.6592 8.45634 43.6231 6.74273 45.3367C5.02912 47.0503 4.06522 49.3737 4.0625 51.7971ZM9.14964 57.6329C9.21542 56.6026 9.67109 55.6359 10.424 54.9295C11.177 54.2231 12.1707 53.8299 13.2031 53.8299C14.2356 53.8299 15.2293 54.2231 15.9822 54.9295C16.7352 55.6359 17.1908 56.6026 17.2566 57.6329C16.0675 58.462 14.6528 58.9066 13.2031 58.9066C11.7535 58.9066 10.3387 58.462 9.14964 57.6329ZM11.1719 49.7659C11.1719 49.3641 11.291 48.9714 11.5142 48.6374C11.7374 48.3033 12.0546 48.043 12.4258 47.8892C12.797 47.7355 13.2054 47.6953 13.5994 47.7736C13.9934 47.852 14.3554 48.0455 14.6394 48.3296C14.9235 48.6136 15.117 48.9756 15.1953 49.3696C15.2737 49.7636 15.2335 50.172 15.0798 50.5432C14.926 50.9144 14.6657 51.2316 14.3316 51.4548C13.9976 51.678 13.6049 51.7971 13.2031 51.7971C12.6646 51.7965 12.1483 51.5823 11.7675 51.2015C11.3867 50.8207 11.1725 50.3044 11.1719 49.7659ZM20.3125 51.7971C20.3137 53.2835 19.8463 54.7324 18.9767 55.938C18.4875 54.499 17.4802 53.2937 16.151 52.5568C16.6977 51.9804 17.0634 51.2563 17.2029 50.4742C17.3423 49.6921 17.2494 48.8862 16.9355 48.1564C16.6217 47.4265 16.1008 46.8047 15.4372 46.3679C14.7736 45.931 13.9965 45.6983 13.202 45.6986C12.4076 45.6989 11.6306 45.9321 10.9673 46.3694C10.3041 46.8067 9.78354 47.4289 9.47022 48.1589C9.15689 48.889 9.06451 49.6949 9.20449 50.4769C9.34448 51.259 9.71069 51.9828 10.2578 52.5588C8.92886 53.2963 7.92164 54.5017 7.43196 55.9405C6.77854 55.0307 6.34939 53.9793 6.17951 52.8722C6.00964 51.765 6.10385 50.6334 6.45447 49.5695C6.80508 48.5057 7.40217 47.5398 8.19705 46.7505C8.99192 45.9613 9.96207 45.3711 11.0284 45.0281C12.0947 44.6851 13.227 44.599 14.3329 44.7768C15.4389 44.9545 16.4871 45.3912 17.3922 46.0511C18.2973 46.711 19.0337 47.5755 19.5412 48.574C20.0486 49.5726 20.3129 50.677 20.3125 51.7971Z"
                      fill="url(#paint1_linear)"
                    />
                    <path
                      d="M51.7969 42.6565C49.989 42.6565 48.2218 43.1926 46.7186 44.197C45.2155 45.2014 44.0439 46.6289 43.352 48.2992C42.6602 49.9694 42.4792 51.8073 42.8319 53.5804C43.1846 55.3535 44.0551 56.9822 45.3335 58.2605C46.6118 59.5389 48.2405 60.4094 50.0136 60.7621C51.7867 61.1148 53.6246 60.9338 55.2948 60.242C56.9651 59.5501 58.3926 58.3785 59.397 56.8754C60.4014 55.3722 60.9375 53.605 60.9375 51.7971C60.9348 49.3737 59.9709 47.0503 58.2573 45.3367C56.5437 43.6231 54.2203 42.6592 51.7969 42.6565ZM47.7434 57.6329C47.8092 56.6026 48.2649 55.6359 49.0178 54.9295C49.7707 54.2231 50.7644 53.8299 51.7969 53.8299C52.8293 53.8299 53.823 54.2231 54.576 54.9295C55.3289 55.6359 55.7846 56.6026 55.8504 57.6329C54.6613 58.462 53.2465 58.9066 51.7969 58.9066C50.3473 58.9066 48.9325 58.462 47.7434 57.6329ZM49.7656 49.7659C49.7656 49.3641 49.8848 48.9714 50.108 48.6374C50.3312 48.3033 50.6484 48.043 51.0196 47.8892C51.3907 47.7355 51.7991 47.6953 52.1932 47.7736C52.5872 47.852 52.9491 48.0455 53.2332 48.3296C53.5173 48.6136 53.7107 48.9756 53.7891 49.3696C53.8675 49.7636 53.8273 50.172 53.6735 50.5432C53.5198 50.9144 53.2594 51.2316 52.9254 51.4548C52.5913 51.678 52.1986 51.7971 51.7969 51.7971C51.2584 51.7965 50.7421 51.5823 50.3613 51.2015C49.9805 50.8207 49.7663 50.3044 49.7656 49.7659ZM57.5705 55.938C57.0813 54.499 56.074 53.2937 54.7447 52.5568C55.2915 51.9804 55.6572 51.2563 55.7966 50.4742C55.9361 49.6921 55.8431 48.8862 55.5293 48.1564C55.2155 47.4265 54.6945 46.8047 54.0309 46.3679C53.3674 45.931 52.5902 45.6983 51.7958 45.6986C51.0013 45.6989 50.2244 45.9321 49.5611 46.3694C48.8978 46.8067 48.3773 47.4289 48.064 48.1589C47.7506 48.889 47.6583 49.6949 47.7982 50.4769C47.9382 51.259 48.3044 51.9828 48.8516 52.5588C47.5226 53.2963 46.5154 54.5017 46.0257 55.9405C45.262 54.8785 44.806 53.6264 44.7081 52.322C44.6101 51.0176 44.8739 49.7115 45.4705 48.5474C46.067 47.3833 46.9732 46.4063 48.0892 45.724C49.2052 45.0417 50.4879 44.6805 51.7959 44.6802C53.104 44.6799 54.3868 45.0405 55.5031 45.7224C56.6194 46.4042 57.526 47.3807 58.1231 48.5446C58.7201 49.7085 58.9845 51.0145 58.8871 52.3189C58.7897 53.6234 58.3344 54.8757 57.5711 55.938H57.5705Z"
                      fill="url(#paint2_linear)"
                    />
                    <path
                      d="M52.8124 39.6528V32.5003C52.8124 32.2309 52.7054 31.9726 52.5149 31.7821C52.3244 31.5917 52.0661 31.4847 51.7968 31.4847H33.5155V25.3477C36.6489 25.0857 39.5598 23.6228 41.6398 21.2647C43.7198 18.9067 44.8079 15.836 44.6768 12.6944C44.5457 9.55279 43.2054 6.58344 40.9361 4.40691C38.6669 2.23039 35.6442 1.01514 32.4999 1.01514C29.3556 1.01514 26.3329 2.23039 24.0636 4.40691C21.7944 6.58344 20.4541 9.55279 20.323 12.6944C20.1919 15.836 21.28 18.9067 23.36 21.2647C25.44 23.6228 28.3509 25.0857 31.4843 25.3477V31.4847H13.203C12.9337 31.4847 12.6753 31.5917 12.4849 31.7821C12.2944 31.9726 12.1874 32.2309 12.1874 32.5003V39.6528C9.05399 39.9149 6.14312 41.3778 4.06312 43.7358C1.98313 46.0939 0.894987 49.1646 1.02612 52.3062C1.15724 55.4478 2.49749 58.4171 4.76676 60.5937C7.03602 62.7702 10.0587 63.9854 13.203 63.9854C16.3473 63.9854 19.37 62.7702 21.6393 60.5937C23.9085 58.4171 25.2488 55.4478 25.3799 52.3062C25.511 49.1646 24.4229 46.0939 22.3429 43.7358C20.2629 41.3778 17.352 39.9149 14.2186 39.6528V33.5159H50.7811V39.6528C47.6477 39.9149 44.7369 41.3778 42.6569 43.7358C40.5769 46.0939 39.4887 49.1646 39.6199 52.3062C39.751 55.4478 41.0912 58.4171 43.3605 60.5937C45.6298 62.7702 48.6524 63.9854 51.7968 63.9854C54.9411 63.9854 57.9637 62.7702 60.233 60.5937C62.5023 58.4171 63.8425 55.4478 63.9737 52.3062C64.1048 49.1646 63.0166 46.0939 60.9366 43.7358C58.8567 41.3778 55.9458 39.9149 52.8124 39.6528ZM23.3593 51.7972C23.3593 53.8059 22.7636 55.7695 21.6476 57.4397C20.5316 59.1099 18.9454 60.4116 17.0896 61.1803C15.2338 61.949 13.1917 62.1501 11.2216 61.7583C9.25151 61.3664 7.44184 60.3991 6.02146 58.9787C4.60108 57.5583 3.63379 55.7487 3.24191 53.7786C2.85003 51.8084 3.05116 49.7663 3.81986 47.9105C4.58856 46.0547 5.89032 44.4685 7.5605 43.3525C9.23069 42.2366 11.1943 41.6409 13.203 41.6409C15.8957 41.644 18.4771 42.7151 20.3811 44.6191C22.2851 46.5231 23.3561 49.1045 23.3593 51.7972ZM22.3436 13.2034C22.3436 11.1947 22.9393 9.23109 24.0553 7.5609C25.1713 5.89071 26.7574 4.58896 28.6133 3.82026C30.4691 3.05156 32.5112 2.85043 34.4813 3.24231C36.4514 3.63419 38.2611 4.60148 39.6814 6.02186C41.1018 7.44223 42.0691 9.25191 42.461 11.222C42.8529 13.1921 42.6517 15.2342 41.883 17.09C41.1143 18.9459 39.8126 20.532 38.1424 21.648C36.4722 22.764 34.5086 23.3597 32.4999 23.3597C29.8072 23.3565 27.2258 22.2855 25.3218 20.3815C23.4178 18.4775 22.3468 15.8961 22.3436 13.2034ZM51.7968 61.9534C49.788 61.9534 47.8244 61.3578 46.1543 60.2418C44.4841 59.1258 43.1823 57.5396 42.4136 55.6838C41.6449 53.828 41.4438 51.7859 41.8357 49.8158C42.2275 47.8457 43.1948 46.036 44.6152 44.6156C46.0356 43.1952 47.8453 42.2279 49.8154 41.8361C51.7855 41.4442 53.8276 41.6453 55.6834 42.414C57.5392 43.1827 59.1254 44.4845 60.2414 46.1547C61.3574 47.8248 61.953 49.7884 61.953 51.7972C61.9499 54.4898 60.8788 57.0713 58.9749 58.9753C57.0709 60.8793 54.4894 61.9503 51.7968 61.9534Z"
                      fill="url(#paint3_linear)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="-6.88288"
                        y1="52.5859"
                        x2="55.1234"
                        y2="-9.42043"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear"
                        x1="402.32"
                        y1="9004.4"
                        x2="9331.23"
                        y2="75.4887"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear"
                        x1="3219.66"
                        y1="11783.2"
                        x2="12148.6"
                        y2="2854.24"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear"
                        x1="3765.6"
                        y1="33262.9"
                        x2="34521.5"
                        y2="2507.73"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h5>
                  <span>Decentralized</span> Lending
                </h5>
                <p>
                  Decentralized Lending This will enable users to benefit from a
                  blockchain agnostic platform that will algorithmically set
                  interest rates that are based on normal supply and demand
                  rules. Users will be able to take out loans and use any
                  cryptocurrency as collateral.
                </p>
              </div>
              <div className="solutions-block">
                <div className="img">
                  <svg
                    width="65"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M60.4297 6.09375H4.57031C3.62788 6.09483 2.72436 6.46968 2.05796 7.13608C1.39156 7.80248 1.0167 8.70601 1.01562 9.64844V55.3516C1.0167 56.294 1.39156 57.1975 2.05796 57.8639C2.72436 58.5303 3.62788 58.9052 4.57031 58.9062H60.4297C61.3721 58.9052 62.2756 58.5303 62.942 57.8639C63.6084 57.1975 63.9833 56.294 63.9844 55.3516V9.64844C63.9833 8.70601 63.6084 7.80248 62.942 7.13608C62.2756 6.46968 61.3721 6.09483 60.4297 6.09375ZM4.57031 8.125H60.4297C60.8336 8.12544 61.2208 8.28608 61.5064 8.57169C61.792 8.85729 61.9527 9.24453 61.9531 9.64844V12.1875H3.04688V9.64844C3.04731 9.24453 3.20796 8.85729 3.49356 8.57169C3.77917 8.28608 4.16641 8.12544 4.57031 8.125ZM60.4297 56.875H4.57031C4.16641 56.8746 3.77917 56.7139 3.49356 56.4283C3.20796 56.1427 3.04731 55.7555 3.04688 55.3516V14.2188H61.9531V55.3516C61.9527 55.7555 61.792 56.1427 61.5064 56.4283C61.2208 56.7139 60.8336 56.8746 60.4297 56.875Z"
                      fill="url(#paint0_linear)"
                    />
                    <path
                      d="M5.07812 11.1719H6.09375C6.36311 11.1719 6.62144 11.0649 6.81191 10.8744C7.00237 10.6839 7.10938 10.4256 7.10938 10.1562C7.10938 9.88689 7.00237 9.62856 6.81191 9.43809C6.62144 9.24763 6.36311 9.14062 6.09375 9.14062H5.07812C4.80876 9.14062 4.55044 9.24763 4.35997 9.43809C4.1695 9.62856 4.0625 9.88689 4.0625 10.1562C4.0625 10.4256 4.1695 10.6839 4.35997 10.8744C4.55044 11.0649 4.80876 11.1719 5.07812 11.1719Z"
                      fill="url(#paint1_linear)"
                    />
                    <path
                      d="M9.14062 11.1719H10.1562C10.4256 11.1719 10.6839 11.0649 10.8744 10.8744C11.0649 10.6839 11.1719 10.4256 11.1719 10.1562C11.1719 9.88689 11.0649 9.62856 10.8744 9.43809C10.6839 9.24763 10.4256 9.14062 10.1562 9.14062H9.14062C8.87126 9.14062 8.61294 9.24763 8.42247 9.43809C8.232 9.62856 8.125 9.88689 8.125 10.1562C8.125 10.4256 8.232 10.6839 8.42247 10.8744C8.61294 11.0649 8.87126 11.1719 9.14062 11.1719Z"
                      fill="url(#paint2_linear)"
                    />
                    <path
                      d="M13.2031 11.1719H14.2188C14.4881 11.1719 14.7464 11.0649 14.9369 10.8744C15.1274 10.6839 15.2344 10.4256 15.2344 10.1562C15.2344 9.88689 15.1274 9.62856 14.9369 9.43809C14.7464 9.24763 14.4881 9.14062 14.2188 9.14062H13.2031C12.9338 9.14062 12.6754 9.24763 12.485 9.43809C12.2945 9.62856 12.1875 9.88689 12.1875 10.1562C12.1875 10.4256 12.2945 10.6839 12.485 10.8744C12.6754 11.0649 12.9338 11.1719 13.2031 11.1719Z"
                      fill="url(#paint3_linear)"
                    />
                    <path
                      d="M32.5 37.5781C34.5087 37.5781 36.4723 36.9825 38.1425 35.8665C39.8127 34.7505 41.1144 33.1643 41.8831 31.3085C42.6518 29.4527 42.853 27.4106 42.4611 25.4405C42.0692 23.4704 41.1019 21.6607 39.6815 20.2403C38.2612 18.8199 36.4515 17.8527 34.4814 17.4608C32.5113 17.0689 30.4692 17.27 28.6134 18.0387C26.7576 18.8074 25.1714 20.1092 24.0554 21.7794C22.9394 23.4496 22.3438 25.4132 22.3438 27.4219C22.3468 30.1145 23.4178 32.696 25.3218 34.6C27.2258 36.504 29.8073 37.5751 32.5 37.5781ZM32.5 19.2969C34.107 19.2969 35.6778 19.7734 37.014 20.6662C38.3501 21.559 39.3915 22.8279 40.0065 24.3126C40.6215 25.7972 40.7824 27.4309 40.4689 29.007C40.1554 30.5831 39.3815 32.0308 38.2452 33.1671C37.1089 34.3034 35.6612 35.0772 34.0851 35.3907C32.509 35.7043 30.8753 35.5434 29.3907 34.9284C27.906 34.3134 26.6371 33.272 25.7443 31.9359C24.8515 30.5997 24.375 29.0288 24.375 27.4219C24.3774 25.2677 25.2342 23.2025 26.7574 21.6793C28.2806 20.1561 30.3459 19.2993 32.5 19.2969Z"
                      fill="url(#paint4_linear)"
                    />
                    <path
                      d="M29.7504 31.1867C29.8447 31.281 29.9566 31.3558 30.0799 31.4069C30.2031 31.4579 30.3352 31.4842 30.4685 31.4842C30.6019 31.4842 30.734 31.4579 30.8572 31.4069C30.9804 31.3558 31.0924 31.281 31.1867 31.1867L37.2805 25.093C37.4709 24.9025 37.5779 24.6442 37.5779 24.3748C37.5779 24.1054 37.4709 23.8471 37.2805 23.6566C37.09 23.4661 36.8316 23.3591 36.5623 23.3591C36.2929 23.3591 36.0346 23.4661 35.8441 23.6566L30.4685 29.0322L29.1555 27.7191C28.965 27.5286 28.7067 27.4216 28.4373 27.4216C28.1679 27.4216 27.9096 27.5286 27.7191 27.7191C27.5286 27.9096 27.4216 28.1679 27.4216 28.4373C27.4216 28.7067 27.5286 28.965 27.7191 29.1555L29.7504 31.1867Z"
                      fill="url(#paint5_linear)"
                    />
                    <path
                      d="M14.2188 48.75H29.4531C29.7225 48.75 29.9808 48.643 30.1713 48.4525C30.3617 48.2621 30.4688 48.0037 30.4688 47.7344C30.4688 47.465 30.3617 47.2067 30.1713 47.0162C29.9808 46.8258 29.7225 46.7188 29.4531 46.7188H14.2188C13.9494 46.7188 13.6911 46.8258 13.5006 47.0162C13.3101 47.2067 13.2031 47.465 13.2031 47.7344C13.2031 48.0037 13.3101 48.2621 13.5006 48.4525C13.6911 48.643 13.9494 48.75 14.2188 48.75Z"
                      fill="url(#paint6_linear)"
                    />
                    <path
                      d="M50.7812 49.7656H14.2188C13.9494 49.7656 13.6911 49.8726 13.5006 50.0631C13.3101 50.2536 13.2031 50.5119 13.2031 50.7812C13.2031 51.0506 13.3101 51.3089 13.5006 51.4994C13.6911 51.6899 13.9494 51.7969 14.2188 51.7969H50.7812C51.0506 51.7969 51.3089 51.6899 51.4994 51.4994C51.6899 51.3089 51.7969 51.0506 51.7969 50.7812C51.7969 50.5119 51.6899 50.2536 51.4994 50.0631C51.3089 49.8726 51.0506 49.7656 50.7812 49.7656Z"
                      fill="url(#paint7_linear)"
                    />
                    <path
                      d="M36.5625 52.8125H24.375C24.1056 52.8125 23.8473 52.9195 23.6568 53.11C23.4664 53.3004 23.3594 53.5588 23.3594 53.8281C23.3594 54.0975 23.4664 54.3558 23.6568 54.5463C23.8473 54.7367 24.1056 54.8438 24.375 54.8438H36.5625C36.8319 54.8438 37.0902 54.7367 37.2807 54.5463C37.4711 54.3558 37.5781 54.0975 37.5781 53.8281C37.5781 53.5588 37.4711 53.3004 37.2807 53.11C37.0902 52.9195 36.8319 52.8125 36.5625 52.8125Z"
                      fill="url(#paint8_linear)"
                    />
                    <path
                      d="M40.625 52.8125H39.6094C39.34 52.8125 39.0817 52.9195 38.8912 53.11C38.7008 53.3004 38.5938 53.5588 38.5938 53.8281C38.5938 54.0975 38.7008 54.3558 38.8912 54.5463C39.0817 54.7367 39.34 54.8438 39.6094 54.8438H40.625C40.8944 54.8438 41.1527 54.7367 41.3432 54.5463C41.5336 54.3558 41.6406 54.0975 41.6406 53.8281C41.6406 53.5588 41.5336 53.3004 41.3432 53.11C41.1527 52.9195 40.8944 52.8125 40.625 52.8125Z"
                      fill="url(#paint9_linear)"
                    />
                    <path
                      d="M50.7812 46.7188H32.5C32.2306 46.7188 31.9723 46.8258 31.7818 47.0162C31.5914 47.2067 31.4844 47.465 31.4844 47.7344C31.4844 48.0037 31.5914 48.2621 31.7818 48.4525C31.9723 48.643 32.2306 48.75 32.5 48.75H50.7812C51.0506 48.75 51.3089 48.643 51.4994 48.4525C51.6899 48.2621 51.7969 48.0037 51.7969 47.7344C51.7969 47.465 51.6899 47.2067 51.4994 47.0162C51.3089 46.8258 51.0506 46.7188 50.7812 46.7188Z"
                      fill="url(#paint10_linear)"
                    />
                    <path
                      d="M25.3906 38.5938C25.1213 38.5938 24.8629 38.7008 24.6725 38.8912C24.482 39.0817 24.375 39.34 24.375 39.6094V42.6562C24.375 42.9256 24.482 43.1839 24.6725 43.3744C24.8629 43.5649 25.1213 43.6719 25.3906 43.6719H39.6094C39.8787 43.6719 40.1371 43.5649 40.3275 43.3744C40.518 43.1839 40.625 42.9256 40.625 42.6562V39.6094C40.625 39.34 40.518 39.0817 40.3275 38.8912C40.1371 38.7008 39.8787 38.5938 39.6094 38.5938H25.3906ZM38.5938 41.6406H26.4062V40.625H38.5938V41.6406Z"
                      fill="url(#paint11_linear)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="-0.17418"
                        y1="65.1742"
                        x2="64.4057"
                        y2="0.594267"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear"
                        x1="-591.212"
                        y1="657.865"
                        x2="362.584"
                        y2="-772.828"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear"
                        x1="-538.399"
                        y1="690.365"
                        x2="415.397"
                        y2="-740.328"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear"
                        x1="-485.587"
                        y1="722.865"
                        x2="468.209"
                        y2="-707.828"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint4_linear"
                        x1="-411.775"
                        y1="10038.9"
                        x2="9921.01"
                        y2="-293.902"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint5_linear"
                        x1="-230.264"
                        y1="3999.54"
                        x2="3802.08"
                        y2="-1040.87"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint6_linear"
                        x1="300.296"
                        y1="1126.07"
                        x2="540.101"
                        y2="-912.277"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint7_linear"
                        x1="2739"
                        y1="1238.8"
                        x2="2847.47"
                        y2="-822.046"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint8_linear"
                        x1="1084.48"
                        y1="1249.97"
                        x2="1373.79"
                        y2="-775.252"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint9_linear"
                        x1="381.757"
                        y1="1327.16"
                        x2="1335.55"
                        y2="-103.532"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint10_linear"
                        x1="1953.62"
                        y1="1284.51"
                        x2="2158.23"
                        y2="-761.591"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint11_linear"
                        x1="554.58"
                        y1="2818.22"
                        x2="2025.44"
                        y2="-1888.53"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h5>
                  <span>Decentralized</span> Options Trading
                </h5>
                <p>
                  Users will have the freedom to exercise options at any given
                  date, European style options will settle automatically on the
                  expiration date.
                </p>
              </div>

              <div className="solutions-block">
                <div className="img">
                  <svg
                    width="65"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M57.8906 5.07812H7.10938C5.49374 5.07984 3.94476 5.72241 2.80234 6.86484C1.65991 8.00726 1.01734 9.55624 1.01562 11.1719V45.7031C1.01734 47.3188 1.65991 48.8677 2.80234 50.0102C3.94476 51.1526 5.49374 51.7952 7.10938 51.7969H22.8744L21.6557 54.8438H18.2812C18.0119 54.8438 17.7536 54.9508 17.5631 55.1412C17.3726 55.3317 17.2656 55.59 17.2656 55.8594V58.9062C17.2656 59.1756 17.3726 59.4339 17.5631 59.6244C17.7536 59.8149 18.0119 59.9219 18.2812 59.9219H46.7188C46.9881 59.9219 47.2464 59.8149 47.4369 59.6244C47.6274 59.4339 47.7344 59.1756 47.7344 58.9062V55.8594C47.7344 55.59 47.6274 55.3317 47.4369 55.1412C47.2464 54.9508 46.9881 54.8438 46.7188 54.8438H43.3443L42.1256 51.7969H57.8906C59.5063 51.7952 61.0552 51.1526 62.1977 50.0102C63.3401 48.8677 63.9827 47.3188 63.9844 45.7031V11.1719C63.9827 9.55624 63.3401 8.00726 62.1977 6.86484C61.0552 5.72241 59.5063 5.07984 57.8906 5.07812ZM45.7031 56.875V57.8906H19.2969V56.875H45.7031ZM23.8443 54.8438L25.0631 51.7969H39.9369L41.1557 54.8438H23.8443ZM57.8906 49.7656H7.10938C6.20892 49.7645 5.33426 49.4649 4.62233 48.9135C3.91041 48.3622 3.40143 47.5903 3.1751 46.7188H61.8249C61.5986 47.5903 61.0896 48.3622 60.3777 48.9135C59.6657 49.4649 58.7911 49.7645 57.8906 49.7656ZM61.9531 44.6875H3.04688V11.1719C3.04788 10.0947 3.47622 9.06202 4.23787 8.30037C4.99952 7.53872 6.03224 7.11038 7.10938 7.10938H57.8906C58.9677 7.11058 60.0003 7.53899 60.7619 8.30059C61.5235 9.06219 61.9519 10.0948 61.9531 11.1719V44.6875Z"
                      fill="url(#paint0_linear)"
                    />
                    <path
                      d="M42.6479 21.6734C42.6517 21.5592 42.6567 21.4437 42.6567 21.3281C42.6567 18.6345 41.5867 16.0512 39.682 14.1466C37.7774 12.2419 35.1941 11.1719 32.5005 11.1719C29.8069 11.1719 27.2236 12.2419 25.3189 14.1466C23.4143 16.0512 22.3442 18.6345 22.3442 21.3281C22.3442 21.4437 22.3493 21.5592 22.3531 21.6734C21.1931 22.3369 20.1755 23.223 19.3587 24.2807C18.5418 25.3384 17.9419 26.5469 17.5933 27.837C17.2446 29.1272 17.1541 30.4734 17.327 31.7986C17.4998 33.1237 17.9326 34.4017 18.6005 35.5592C19.2685 36.7167 20.1583 37.731 21.2191 38.5437C22.2799 39.3565 23.4908 39.9519 24.7822 40.2956C26.0736 40.6394 27.4202 40.7247 28.7447 40.5468C30.0692 40.3689 31.3455 39.9313 32.5005 39.259C34.8325 40.6046 37.6035 40.9687 40.204 40.2713C42.8044 39.5738 45.0213 37.8719 46.3669 35.5399C47.7126 33.2079 48.0767 30.4369 47.3792 27.8364C46.6818 25.2359 44.9798 23.0191 42.6479 21.6734ZM32.5005 13.2031C34.5584 13.2056 36.5388 13.9881 38.0425 15.3929C39.5463 16.7978 40.4616 18.7204 40.6039 20.7733C39.2641 20.3549 37.8521 20.2193 36.4572 20.3752C35.0623 20.531 33.7149 20.9748 32.5005 21.6785C31.2861 20.9748 29.9387 20.531 28.5438 20.3752C27.1489 20.2193 25.7368 20.3549 24.3971 20.7733C24.5394 18.7204 25.4547 16.7978 26.9585 15.3929C28.4622 13.9881 30.4426 13.2056 32.5005 13.2031ZM32.5005 24.1325C34.0016 25.3347 35.028 27.03 35.3976 28.9174C33.5322 29.6317 31.4688 29.6317 29.6034 28.9174C29.973 27.03 30.9994 25.3347 32.5005 24.1325ZM27.7486 27.9132C26.0751 26.7044 24.923 24.9052 24.5253 22.8795C26.5155 22.1173 28.726 22.1702 30.6774 23.0268C29.2551 24.3429 28.2389 26.0384 27.7486 27.9132ZM34.3235 23.0268C36.275 22.1702 38.4855 22.1173 40.4757 22.8795C40.078 24.9052 38.9259 26.7044 37.2523 27.9132C36.7621 26.0384 35.7459 24.3429 34.3235 23.0268ZM27.4224 38.5937C25.7043 38.5945 24.0302 38.0505 22.6409 37.0397C21.2516 36.029 20.2186 34.6038 19.6905 32.9689C19.1624 31.334 19.1663 29.5737 19.7018 27.9413C20.2373 26.3088 21.2767 24.8881 22.6705 23.8837C23.0126 25.1866 23.6095 26.4089 24.4266 27.4799C25.2437 28.5509 26.2649 29.4493 27.4313 30.1234C27.4275 30.2377 27.4224 30.3532 27.4224 30.4687C27.4218 31.8667 27.7107 33.2496 28.271 34.5305C28.8312 35.8113 29.6505 36.9622 30.6774 37.9107C29.6515 38.3617 28.543 38.5943 27.4224 38.5937ZM32.5005 36.805C31.6236 36.1031 30.9019 35.2269 30.3812 34.2317C29.8604 33.2365 29.5519 32.1441 29.4752 31.0235C31.4453 31.638 33.5557 31.638 35.5258 31.0235C35.4491 32.1441 35.1406 33.2365 34.6198 34.2317C34.0991 35.2269 33.3774 36.1031 32.5005 36.805ZM37.5786 38.5937C36.458 38.5943 35.3495 38.3617 34.3235 37.9107C35.3504 36.9622 36.1698 35.8113 36.73 34.5305C37.2902 33.2496 37.5792 31.8667 37.5786 30.4687C37.5786 30.3532 37.5735 30.2377 37.5697 30.1234C38.7361 29.4493 39.7573 28.5509 40.5744 27.4799C41.3915 26.4089 41.9884 25.1866 42.3305 23.8837C43.7243 24.8881 44.7637 26.3088 45.2992 27.9413C45.8347 29.5737 45.8386 31.334 45.3105 32.9689C44.7824 34.6038 43.7494 36.029 42.3601 37.0397C40.9707 38.0505 39.2967 38.5945 37.5786 38.5937Z"
                      fill="url(#paint1_linear)"
                    />
                    <path
                      d="M6.09375 16.25H10.1562C10.4256 16.25 10.6839 16.143 10.8744 15.9525C11.0649 15.7621 11.1719 15.5037 11.1719 15.2344V11.1719C11.1719 10.9025 11.0649 10.6442 10.8744 10.4537C10.6839 10.2633 10.4256 10.1562 10.1562 10.1562H6.09375C5.82439 10.1562 5.56606 10.2633 5.37559 10.4537C5.18513 10.6442 5.07812 10.9025 5.07812 11.1719V15.2344C5.07812 15.5037 5.18513 15.7621 5.37559 15.9525C5.56606 16.143 5.82439 16.25 6.09375 16.25ZM7.10938 12.1875H9.14062V14.2188H7.10938V12.1875Z"
                      fill="url(#paint2_linear)"
                    />
                    <path
                      d="M13.2031 14.2187H16.845L19.5943 16.9682C19.6886 17.0625 19.8006 17.1373 19.9238 17.1883C20.0471 17.2394 20.1791 17.2657 20.3125 17.2657C20.4459 17.2657 20.5779 17.2394 20.7012 17.1883C20.8244 17.1373 20.9364 17.0625 21.0307 16.9682C21.125 16.8739 21.1998 16.7619 21.2508 16.6387C21.3019 16.5154 21.3282 16.3834 21.3282 16.25C21.3282 16.1166 21.3019 15.9846 21.2508 15.8613C21.1998 15.7381 21.125 15.6261 21.0307 15.5318L17.9838 12.485C17.8895 12.3906 17.7775 12.3158 17.6543 12.2648C17.5311 12.2138 17.399 12.1875 17.2656 12.1875H13.2031C12.9338 12.1875 12.6754 12.2945 12.485 12.485C12.2945 12.6754 12.1875 12.9338 12.1875 13.2031C12.1875 13.4725 12.2945 13.7308 12.485 13.9213C12.6754 14.1117 12.9338 14.2187 13.2031 14.2187Z"
                      fill="url(#paint3_linear)"
                    />
                    <path
                      d="M54.8438 19.2969H58.9062C59.1756 19.2969 59.4339 19.1899 59.6244 18.9994C59.8149 18.8089 59.9219 18.5506 59.9219 18.2812V14.2188C59.9219 13.9494 59.8149 13.6911 59.6244 13.5006C59.4339 13.3101 59.1756 13.2031 58.9062 13.2031H54.8438C54.5744 13.2031 54.3161 13.3101 54.1256 13.5006C53.9351 13.6911 53.8281 13.9494 53.8281 14.2188V18.2812C53.8281 18.5506 53.9351 18.8089 54.1256 18.9994C54.3161 19.1899 54.5744 19.2969 54.8438 19.2969ZM55.8594 15.2344H57.8906V17.2656H55.8594V15.2344Z"
                      fill="url(#paint4_linear)"
                    />
                    <path
                      d="M44.6873 20.3125C44.8207 20.3127 44.9528 20.2865 45.0761 20.2355C45.1993 20.1844 45.3113 20.1095 45.4055 20.0151L48.1548 17.2656H51.7967C52.066 17.2656 52.3244 17.1586 52.5148 16.9682C52.7053 16.7777 52.8123 16.5194 52.8123 16.25C52.8123 15.9806 52.7053 15.7223 52.5148 15.5318C52.3244 15.3414 52.066 15.2344 51.7967 15.2344H47.7342C47.6008 15.2344 47.4687 15.2606 47.3455 15.3117C47.2223 15.3627 47.1103 15.4375 47.016 15.5318L43.9691 18.5787C43.8271 18.7207 43.7303 18.9017 43.6911 19.0987C43.652 19.2957 43.6721 19.5 43.7489 19.6855C43.8258 19.8711 43.956 20.0298 44.123 20.1414C44.29 20.253 44.4864 20.3125 44.6873 20.3125Z"
                      fill="url(#paint5_linear)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="-1.72809"
                        y1="62.6656"
                        x2="62.7833"
                        y2="-1.84577"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear"
                        x1="-1.72758"
                        y1="62.6656"
                        x2="62.7838"
                        y2="-1.84576"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear"
                        x1="-1028.49"
                        y1="2067.48"
                        x2="2068.05"
                        y2="-1029.07"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear"
                        x1="-1172.55"
                        y1="1929.76"
                        x2="1018.42"
                        y2="-2013.97"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint4_linear"
                        x1="263.38"
                        y1="3313.65"
                        x2="3359.93"
                        y2="217.106"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint5_linear"
                        x1="102.062"
                        y1="2623.42"
                        x2="2293.01"
                        y2="-1320.3"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h5>
                  <span>Decentralised</span> Futures trading
                </h5>
                <p>
                  Users will be able to increase their position size and use
                  this to facilitate margin trading without relying on a
                  centralized entity. These Bitcoin and other Crypto asset
                  futures could either be settled in cash or by Physical
                  delivery of the asset on settlement.
                </p>
              </div>

              <div className="solutions-block">
                <div className="img">
                  <svg
                    width="65"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M44.6875 1.01562H20.3125C18.6969 1.01734 17.1479 1.65991 16.0055 2.80234C14.863 3.94476 14.2205 5.49374 14.2188 7.10938V57.8906C14.2205 59.5063 14.863 61.0552 16.0055 62.1977C17.1479 63.3401 18.6969 63.9827 20.3125 63.9844H44.6875C46.3031 63.9827 47.8521 63.3401 48.9945 62.1977C50.137 61.0552 50.7795 59.5063 50.7812 57.8906V7.10938C50.7795 5.49374 50.137 3.94476 48.9945 2.80234C47.8521 1.65991 46.3031 1.01734 44.6875 1.01562ZM38.3081 3.04688L37.8003 5.07812H27.1997L26.6919 3.04688H38.3081ZM48.75 57.8906C48.7486 58.9676 48.3201 60.0001 47.5586 60.7617C46.797 61.5233 45.7645 61.9517 44.6875 61.9531H20.3125C19.2355 61.9517 18.203 61.5233 17.4414 60.7617C16.6799 60.0001 16.2514 58.9676 16.25 57.8906V7.10938C16.2514 6.03237 16.6799 4.99987 17.4414 4.23831C18.203 3.47675 19.2355 3.04829 20.3125 3.04688H24.5972L25.4211 6.34004C25.476 6.55976 25.6028 6.75482 25.7813 6.89421C25.9598 7.03361 26.1798 7.10934 26.4062 7.10938H38.5938C38.8202 7.10934 39.0402 7.03361 39.2187 6.89421C39.3972 6.75482 39.524 6.55976 39.5789 6.34004L40.4028 3.04688H44.6875C45.7645 3.04829 46.797 3.47675 47.5586 4.23831C48.3201 4.99987 48.7486 6.03237 48.75 7.10938V57.8906Z"
                      fill="url(#paint0_linear)"
                    />
                    <path
                      d="M37.5781 58.9062H27.4219C27.1525 58.9062 26.8942 59.0133 26.7037 59.2037C26.5133 59.3942 26.4062 59.6525 26.4062 59.9219C26.4062 60.1912 26.5133 60.4496 26.7037 60.64C26.8942 60.8305 27.1525 60.9375 27.4219 60.9375H37.5781C37.8475 60.9375 38.1058 60.8305 38.2963 60.64C38.4867 60.4496 38.5938 60.1912 38.5938 59.9219C38.5938 59.6525 38.4867 59.3942 38.2963 59.2037C38.1058 59.0133 37.8475 58.9062 37.5781 58.9062Z"
                      fill="url(#paint1_linear)"
                    />
                    <path
                      d="M43.6719 31.4844C43.4025 31.4844 43.1442 31.5914 42.9537 31.7818C42.7633 31.9723 42.6562 32.2306 42.6562 32.5C42.6532 35.1927 41.5822 37.7742 39.6782 39.6782C37.7742 41.5822 35.1927 42.6532 32.5 42.6563C30.1111 42.665 27.7972 41.823 25.9725 40.2812L27.57 39.1871L22.0898 36.5625L22.5563 42.621L24.2447 41.4648C26.4885 43.5467 29.4392 44.6986 32.5 44.6875C35.7312 44.6839 38.829 43.3987 41.1139 41.1139C43.3987 38.829 44.6839 35.7312 44.6875 32.5C44.6875 32.2306 44.5805 31.9723 44.39 31.7818C44.1996 31.5914 43.9412 31.4844 43.6719 31.4844Z"
                      fill="url(#paint2_linear)"
                    />
                    <path
                      d="M32.5 22.3436C34.8889 22.3349 37.2028 23.1768 39.0275 24.7186L37.43 25.8127L42.9102 28.4373L42.4437 22.3789L40.7553 23.5349C38.5115 21.4531 35.5608 20.3013 32.5 20.3123C29.2688 20.316 26.171 21.6012 23.8861 23.886C21.6013 26.1708 20.3161 29.2686 20.3125 32.4998C20.3125 32.7692 20.4195 33.0275 20.61 33.218C20.8004 33.4085 21.0588 33.5155 21.3281 33.5155C21.5975 33.5155 21.8558 33.4085 22.0463 33.218C22.2367 33.0275 22.3438 32.7692 22.3438 32.4998C22.3468 29.8072 23.4178 27.2257 25.3218 25.3217C27.2258 23.4177 29.8073 22.3466 32.5 22.3436Z"
                      fill="url(#paint3_linear)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="3.67326"
                        y1="61.3267"
                        x2="56.5965"
                        y2="8.40354"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear"
                        x1="1695.29"
                        y1="1259.51"
                        x2="1969.92"
                        y2="-388.262"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear"
                        x1="1160.09"
                        y1="6692.39"
                        x2="5954.97"
                        y2="-1514.19"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear"
                        x1="189.999"
                        y1="6115.46"
                        x2="4984.88"
                        y2="-2091.12"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h5>
                  <span>Cross</span> Chain Swaps
                </h5>
                <p>
                  Native cross chain swaps that allows Bitcoin to swap with
                  Dash, Dash with Ethereum etc. Without an intermediary.
                </p>
              </div>

              <div className="solutions-block">
                <div className="img">
                  <svg
                    width="65"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M60.4297 1.01562H4.57031C3.62788 1.0167 2.72436 1.39156 2.05796 2.05796C1.39156 2.72436 1.0167 3.62788 1.01562 4.57031V60.4297C1.0167 61.3721 1.39156 62.2756 2.05796 62.942C2.72436 63.6084 3.62788 63.9833 4.57031 63.9844H60.4297C61.3721 63.9833 62.2756 63.6084 62.942 62.942C63.6084 62.2756 63.9833 61.3721 63.9844 60.4297V4.57031C63.9833 3.62788 63.6084 2.72436 62.942 2.05796C62.2756 1.39156 61.3721 1.0167 60.4297 1.01562ZM61.9531 60.4297C61.9527 60.8336 61.792 61.2208 61.5064 61.5064C61.2208 61.792 60.8336 61.9527 60.4297 61.9531H4.57031C4.16641 61.9527 3.77917 61.792 3.49356 61.5064C3.20796 61.2208 3.04731 60.8336 3.04688 60.4297V4.57031C3.04731 4.16641 3.20796 3.77917 3.49356 3.49356C3.77917 3.20796 4.16641 3.04731 4.57031 3.04688H60.4297C60.8336 3.04731 61.2208 3.20796 61.5064 3.49356C61.792 3.77917 61.9527 4.16641 61.9531 4.57031V60.4297Z"
                      fill="url(#paint0_linear)"
                    />
                    <path
                      d="M39.6094 24.375H25.3906C25.1213 24.375 24.8629 24.482 24.6725 24.6725C24.482 24.8629 24.375 25.1213 24.375 25.3906V39.6094C24.375 39.8787 24.482 40.1371 24.6725 40.3275C24.8629 40.518 25.1213 40.625 25.3906 40.625H39.6094C39.8787 40.625 40.1371 40.518 40.3275 40.3275C40.518 40.1371 40.625 39.8787 40.625 39.6094V25.3906C40.625 25.1213 40.518 24.8629 40.3275 24.6725C40.1371 24.482 39.8787 24.375 39.6094 24.375ZM38.5938 38.5938H26.4062V26.4062H38.5938V38.5938Z"
                      fill="url(#paint1_linear)"
                    />
                    <path
                      d="M22.3438 24.375H8.125C7.85564 24.375 7.59731 24.482 7.40684 24.6725C7.21638 24.8629 7.10938 25.1213 7.10938 25.3906V39.6094C7.10938 39.8787 7.21638 40.1371 7.40684 40.3275C7.59731 40.518 7.85564 40.625 8.125 40.625H22.3438C22.6131 40.625 22.8714 40.518 23.0619 40.3275C23.2524 40.1371 23.3594 39.8787 23.3594 39.6094V25.3906C23.3594 25.1213 23.2524 24.8629 23.0619 24.6725C22.8714 24.482 22.6131 24.375 22.3438 24.375ZM21.3281 38.5938H9.14062V26.4062H21.3281V38.5938Z"
                      fill="url(#paint2_linear)"
                    />
                    <path
                      d="M56.875 24.375H42.6562C42.3869 24.375 42.1286 24.482 41.9381 24.6725C41.7476 24.8629 41.6406 25.1213 41.6406 25.3906V39.6094C41.6406 39.8787 41.7476 40.1371 41.9381 40.3275C42.1286 40.518 42.3869 40.625 42.6562 40.625H56.875C57.1444 40.625 57.4027 40.518 57.5932 40.3275C57.7836 40.1371 57.8906 39.8787 57.8906 39.6094V25.3906C57.8906 25.1213 57.7836 24.8629 57.5932 24.6725C57.4027 24.482 57.1444 24.375 56.875 24.375ZM55.8594 38.5938H43.6719V26.4062H55.8594V38.5938Z"
                      fill="url(#paint3_linear)"
                    />
                    <path
                      d="M39.6094 7.10938H25.3906C25.1213 7.10938 24.8629 7.21638 24.6725 7.40684C24.482 7.59731 24.375 7.85564 24.375 8.125V22.3438C24.375 22.6131 24.482 22.8714 24.6725 23.0619C24.8629 23.2524 25.1213 23.3594 25.3906 23.3594H39.6094C39.8787 23.3594 40.1371 23.2524 40.3275 23.0619C40.518 22.8714 40.625 22.6131 40.625 22.3438V8.125C40.625 7.85564 40.518 7.59731 40.3275 7.40684C40.1371 7.21638 39.8787 7.10938 39.6094 7.10938ZM38.5938 21.3281H26.4062V9.14062H38.5938V21.3281Z"
                      fill="url(#paint4_linear)"
                    />
                    <path
                      d="M22.3438 7.10938H8.125C7.85564 7.10938 7.59731 7.21638 7.40684 7.40684C7.21638 7.59731 7.10938 7.85564 7.10938 8.125V22.3438C7.10938 22.6131 7.21638 22.8714 7.40684 23.0619C7.59731 23.2524 7.85564 23.3594 8.125 23.3594H22.3438C22.6131 23.3594 22.8714 23.2524 23.0619 23.0619C23.2524 22.8714 23.3594 22.6131 23.3594 22.3438V8.125C23.3594 7.85564 23.2524 7.59731 23.0619 7.40684C22.8714 7.21638 22.6131 7.10938 22.3438 7.10938ZM21.3281 21.3281H9.14062V9.14062H21.3281V21.3281Z"
                      fill="url(#paint5_linear)"
                    />
                    <path
                      d="M56.875 7.10938H42.6562C42.3869 7.10938 42.1286 7.21638 41.9381 7.40684C41.7476 7.59731 41.6406 7.85564 41.6406 8.125V22.3438C41.6406 22.6131 41.7476 22.8714 41.9381 23.0619C42.1286 23.2524 42.3869 23.3594 42.6562 23.3594H56.875C57.1444 23.3594 57.4027 23.2524 57.5932 23.0619C57.7836 22.8714 57.8906 22.6131 57.8906 22.3438V8.125C57.8906 7.85564 57.7836 7.59731 57.5932 7.40684C57.4027 7.21638 57.1444 7.10938 56.875 7.10938ZM55.8594 21.3281H43.6719V9.14062H55.8594V21.3281Z"
                      fill="url(#paint6_linear)"
                    />
                    <path
                      d="M39.6094 41.6406H25.3906C25.1213 41.6406 24.8629 41.7476 24.6725 41.9381C24.482 42.1286 24.375 42.3869 24.375 42.6562V56.875C24.375 57.1444 24.482 57.4027 24.6725 57.5932C24.8629 57.7836 25.1213 57.8906 25.3906 57.8906H39.6094C39.8787 57.8906 40.1371 57.7836 40.3275 57.5932C40.518 57.4027 40.625 57.1444 40.625 56.875V42.6562C40.625 42.3869 40.518 42.1286 40.3275 41.9381C40.1371 41.7476 39.8787 41.6406 39.6094 41.6406ZM38.5938 55.8594H26.4062V43.6719H38.5938V55.8594Z"
                      fill="url(#paint7_linear)"
                    />
                    <path
                      d="M22.3438 41.6406H8.125C7.85564 41.6406 7.59731 41.7476 7.40684 41.9381C7.21638 42.1286 7.10938 42.3869 7.10938 42.6562V56.875C7.10938 57.1444 7.21638 57.4027 7.40684 57.5932C7.59731 57.7836 7.85564 57.8906 8.125 57.8906H22.3438C22.6131 57.8906 22.8714 57.7836 23.0619 57.5932C23.2524 57.4027 23.3594 57.1444 23.3594 56.875V42.6562C23.3594 42.3869 23.2524 42.1286 23.0619 41.9381C22.8714 41.7476 22.6131 41.6406 22.3438 41.6406ZM21.3281 55.8594H9.14062V43.6719H21.3281V55.8594Z"
                      fill="url(#paint8_linear)"
                    />
                    <path
                      d="M56.875 41.6406H42.6562C42.3869 41.6406 42.1286 41.7476 41.9381 41.9381C41.7476 42.1286 41.6406 42.3869 41.6406 42.6562V56.875C41.6406 57.1444 41.7476 57.4027 41.9381 57.5932C42.1286 57.7836 42.3869 57.8906 42.6562 57.8906H56.875C57.1444 57.8906 57.4027 57.7836 57.5932 57.5932C57.7836 57.4027 57.8906 57.1444 57.8906 56.875V42.6562C57.8906 42.3869 57.7836 42.1286 57.5932 41.9381C57.4027 41.7476 57.1444 41.6406 56.875 41.6406ZM55.8594 55.8594H43.6719V43.6719H55.8594V55.8594Z"
                      fill="url(#paint9_linear)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="5.37266"
                        y1="59.6273"
                        x2="61.7384"
                        y2="3.26155"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear"
                        x1="5.37266"
                        y1="59.6273"
                        x2="61.7384"
                        y2="3.26155"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear"
                        x1="-410.191"
                        y1="6551.68"
                        x2="6804.63"
                        y2="-663.146"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear"
                        x1="1834.34"
                        y1="8761.68"
                        x2="9049.16"
                        y2="1546.85"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint4_linear"
                        x1="-392.925"
                        y1="6534.41"
                        x2="6821.9"
                        y2="-680.412"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint5_linear"
                        x1="-1515.19"
                        y1="5429.41"
                        x2="5699.63"
                        y2="-1785.41"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint6_linear"
                        x1="5.37265"
                        y1="59.6273"
                        x2="61.7384"
                        y2="3.26155"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint7_linear"
                        x1="1817.08"
                        y1="8778.94"
                        x2="9031.9"
                        y2="1564.12"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint8_linear"
                        x1="5.37266"
                        y1="59.6273"
                        x2="61.7385"
                        y2="3.26155"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint9_linear"
                        x1="2939.34"
                        y1="9883.94"
                        x2="10154.2"
                        y2="2669.12"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h5>
                  <span>Asset</span> Digitization
                </h5>
                <p>
                  Asset digitization can final be implemented and deployed
                  without the need for centralized exchange listings.
                </p>
              </div>

              <div className="solutions-block">
                <div className="img">
                  <svg
                    width="65"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M60.9375 11.1719H4.0625C3.25442 11.1719 2.47943 11.4929 1.90803 12.0643C1.33663 12.6357 1.01563 13.4107 1.01562 14.2188V44.6875C1.01563 45.4956 1.33663 46.2706 1.90803 46.842C2.47943 47.4134 3.25442 47.7344 4.0625 47.7344H25.1062L24.5984 49.7656H21.3281C21.0588 49.7656 20.8004 49.8726 20.61 50.0631C20.4195 50.2536 20.3125 50.5119 20.3125 50.7812V53.8281C20.3125 54.0975 20.4195 54.3558 20.61 54.5463C20.8004 54.7367 21.0588 54.8438 21.3281 54.8438H43.6719C43.9412 54.8438 44.1996 54.7367 44.39 54.5463C44.5805 54.3558 44.6875 54.0975 44.6875 53.8281V50.7812C44.6875 50.5119 44.5805 50.2536 44.39 50.0631C44.1996 49.8726 43.9412 49.7656 43.6719 49.7656H40.4016L39.8937 47.7344H60.9375C61.7456 47.7344 62.5206 47.4134 63.092 46.842C63.6634 46.2706 63.9844 45.4956 63.9844 44.6875V14.2188C63.9844 13.4107 63.6634 12.6357 63.092 12.0643C62.5206 11.4929 61.7456 11.1719 60.9375 11.1719ZM3.04688 14.2188C3.04688 13.9494 3.15388 13.6911 3.34434 13.5006C3.53481 13.3101 3.79314 13.2031 4.0625 13.2031H60.9375C61.2069 13.2031 61.4652 13.3101 61.6557 13.5006C61.8461 13.6911 61.9531 13.9494 61.9531 14.2188V39.6094H3.04688V14.2188ZM42.6562 52.8125H22.3438V51.7969H42.6562V52.8125ZM38.3084 49.7656H26.6916L27.1995 47.7344H37.8005L38.3084 49.7656ZM61.9531 44.6875C61.9531 44.9569 61.8461 45.2152 61.6557 45.4057C61.4652 45.5961 61.2069 45.7031 60.9375 45.7031H4.0625C3.79314 45.7031 3.53481 45.5961 3.34434 45.4057C3.15388 45.2152 3.04688 44.9569 3.04688 44.6875V41.6406H61.9531V44.6875Z"
                      fill="url(#paint0_linear)"
                    />
                    <path
                      d="M6.09375 44.6875H10.1562C10.4256 44.6875 10.6839 44.5805 10.8744 44.39C11.0649 44.1996 11.1719 43.9412 11.1719 43.6719C11.1719 43.4025 11.0649 43.1442 10.8744 42.9537C10.6839 42.7633 10.4256 42.6562 10.1562 42.6562H6.09375C5.82439 42.6562 5.56606 42.7633 5.37559 42.9537C5.18513 43.1442 5.07812 43.4025 5.07812 43.6719C5.07812 43.9412 5.18513 44.1996 5.37559 44.39C5.56606 44.5805 5.82439 44.6875 6.09375 44.6875Z"
                      fill="url(#paint1_linear)"
                    />
                    <path
                      d="M13.2031 44.6875H14.2188C14.4881 44.6875 14.7464 44.5805 14.9369 44.39C15.1274 44.1996 15.2344 43.9412 15.2344 43.6719C15.2344 43.4025 15.1274 43.1442 14.9369 42.9537C14.7464 42.7633 14.4881 42.6562 14.2188 42.6562H13.2031C12.9338 42.6562 12.6754 42.7633 12.485 42.9537C12.2945 43.1442 12.1875 43.4025 12.1875 43.6719C12.1875 43.9412 12.2945 44.1996 12.485 44.39C12.6754 44.5805 12.9338 44.6875 13.2031 44.6875Z"
                      fill="url(#paint2_linear)"
                    />
                    <path
                      d="M33.0698 19.4715C33.0089 19.4309 32.9439 19.3968 32.8758 19.37L22.7195 15.3075C22.4774 15.212 22.2081 15.212 21.9659 15.3075L11.8097 19.37C11.7415 19.3966 11.6764 19.4307 11.6157 19.4715C11.4787 19.5649 11.3667 19.6903 11.2893 19.8369C11.2119 19.9834 11.1716 20.1467 11.1719 20.3125V32.5C11.1718 32.7031 11.2326 32.9016 11.3465 33.0698C11.4604 33.238 11.6221 33.3681 11.8107 33.4435L21.967 37.506C21.9781 37.506 21.9913 37.506 22.0025 37.5121C22.2215 37.6002 22.466 37.6002 22.685 37.5121C22.6962 37.5121 22.7094 37.5121 22.7205 37.506L32.8768 33.4435C33.0654 33.3681 33.2271 33.238 33.341 33.0698C33.4549 32.9016 33.5157 32.7031 33.5156 32.5V20.3125C33.5157 20.1465 33.475 19.9831 33.3973 19.8365C33.3196 19.6899 33.2071 19.5646 33.0698 19.4715ZM22.3438 17.3438L29.7649 20.3125L22.3438 23.2811L14.9226 20.3125L22.3438 17.3438ZM13.2031 21.8126L21.3281 25.0626V35.0624L13.2031 31.8124V21.8126ZM31.4844 31.8124L23.3594 35.0624V25.0626L31.4844 21.8126V31.8124Z"
                      fill="url(#paint3_linear)"
                    />
                    <path
                      d="M41.2344 22.5469C41.1277 22.4669 41.0063 22.4086 40.8771 22.3755C40.7479 22.3424 40.6134 22.3351 40.4814 22.354C40.3493 22.3728 40.2223 22.4175 40.1075 22.4855C39.9928 22.5534 39.8925 22.6433 39.8125 22.75L36.7656 26.8125C36.6338 26.9883 36.5625 27.2021 36.5625 27.4219C36.5625 27.6416 36.6338 27.8555 36.7656 28.0313L39.8125 32.0938C39.8925 32.2005 39.9928 32.2903 40.1075 32.3583C40.2223 32.4262 40.3493 32.4709 40.4814 32.4898C40.6134 32.5087 40.7479 32.5013 40.8771 32.4682C41.0063 32.4351 41.1277 32.3769 41.2344 32.2969C41.3411 32.2169 41.431 32.1166 41.4989 32.0018C41.5669 31.8871 41.6116 31.76 41.6304 31.628C41.6493 31.496 41.6419 31.3615 41.6088 31.2323C41.5757 31.1031 41.5175 30.9817 41.4375 30.875L38.8477 27.4219L41.4375 23.9688C41.5991 23.7533 41.6685 23.4824 41.6304 23.2157C41.5923 22.9491 41.4499 22.7085 41.2344 22.5469Z"
                      fill="url(#paint4_linear)"
                    />
                    <path
                      d="M51.5938 22.75C51.4321 22.5345 51.1915 22.3921 50.9249 22.354C50.6582 22.3159 50.3874 22.3853 50.1719 22.5469C49.9564 22.7085 49.8139 22.9491 49.7758 23.2157C49.7377 23.4824 49.8071 23.7533 49.9688 23.9688L52.5586 27.4219L49.9688 30.875C49.8071 31.0905 49.7377 31.3614 49.7758 31.628C49.8139 31.8947 49.9564 32.1353 50.1719 32.2969C50.3874 32.4585 50.6582 32.5279 50.9249 32.4898C51.1915 32.4517 51.4321 32.3092 51.5938 32.0938L54.6406 28.0313C54.7725 27.8555 54.8438 27.6416 54.8438 27.4219C54.8438 27.2021 54.7725 26.9883 54.6406 26.8125L51.5938 22.75Z"
                      fill="url(#paint5_linear)"
                    />
                    <path
                      d="M48.188 22.4505C48.0687 22.3908 47.9387 22.3552 47.8056 22.3458C47.6725 22.3364 47.5389 22.3533 47.4123 22.3955C47.2857 22.4378 47.1687 22.5046 47.0679 22.5921C46.9672 22.6796 46.8847 22.7861 46.8251 22.9055L42.7626 31.0305C42.6422 31.2715 42.6225 31.5506 42.7078 31.8062C42.7931 32.0618 42.9765 32.273 43.2176 32.3934C43.4587 32.5138 43.7377 32.5335 43.9933 32.4482C44.2489 32.3629 44.4601 32.1795 44.5806 31.9384L48.643 23.8134C48.7027 23.6941 48.7383 23.5641 48.7477 23.431C48.7571 23.2979 48.7403 23.1642 48.698 23.0377C48.6557 22.9111 48.589 22.7941 48.5015 22.6933C48.414 22.5926 48.3075 22.51 48.188 22.4505Z"
                      fill="url(#paint6_linear)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="-0.631719"
                        y1="62.5848"
                        x2="65.7038"
                        y2="-3.7507"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear"
                        x1="-29.1809"
                        y1="157.67"
                        x2="50.4217"
                        y2="-81.1383"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear"
                        x1="3.43687"
                        y1="163.256"
                        x2="125.902"
                        y2="-20.4428"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear"
                        x1="-147.96"
                        y1="1246.79"
                        x2="1311.33"
                        y2="-212.592"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint4_linear"
                        x1="48.6383"
                        y1="678.661"
                        x2="579.323"
                        y2="413.319"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint5_linear"
                        x1="87.232"
                        y1="729.443"
                        x2="617.917"
                        y2="464.101"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                      <linearGradient
                        id="paint6_linear"
                        x1="72.3857"
                        y1="704.118"
                        x2="657.774"
                        y2="352.861"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#003F8A" />
                        <stop offset="0.518" stop-color="#00D7DF" />
                        <stop offset="1" stop-color="#006DF0" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h5>
                  <span>Anker</span> True Dex
                </h5>
                <p>
                  A decentralized exchange that has not been seen before that
                  utilizes the AnkerSwaps. This will also solve decentralized
                  exchanges' low volume.
                </p>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    );
  }
}

export default Solutions;
